exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.daterangepicker.dropdown-menu {\n    min-width: 700px !important;\n}\n", ""]);

